"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGradientEndColor = exports.getButtonBackgroundHover = exports.getButtonBackground = void 0;
var _icfPlatformid = require("@atg/icf-platformid");
var _tinycolor = require("@ctrl/tinycolor");
var _colorUtils = require("../../utils/colorUtils");
/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var getGradientEndColor = exports.getGradientEndColor = function getGradientEndColor(myColor) {
  var color = typeof myColor === "string" ? new _tinycolor.TinyColor(myColor) : myColor;
  return color.spin(-355).darken(21).saturate(5);
};
var getBackgroundColor = function getBackgroundColor(myColor) {
  var color = typeof myColor === "string" ? new _tinycolor.TinyColor(myColor) : myColor;
  return "linear-gradient(to bottom, ".concat(color, " 0%,") + "".concat(getGradientEndColor(color), " 100%)");
};
var getButtonBackground = exports.getButtonBackground = function getButtonBackground(theme, backgroundColor) {
  switch (theme.themeProviderProps.platformId) {
    case _icfPlatformid.PlatformId.kwiky:
      return getBackgroundColor(backgroundColor || theme.colors.primary);
    default:
      return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.colors.primary;
  }
};
var getButtonBackgroundHover = exports.getButtonBackgroundHover = function getButtonBackgroundHover(theme, backgroundColor) {
  switch (theme.themeProviderProps.platformId) {
    case _icfPlatformid.PlatformId.kwiky:
      return getBackgroundColor((0, _colorUtils.getHoverColor)(backgroundColor || theme.colors.primary));
    case _icfPlatformid.PlatformId.cambuilder:
      return backgroundColor ? (0, _colorUtils.getHoverColor)(backgroundColor).toHexString() : (0, _colorUtils.getHoverColor)(theme.colors.primary, 170, 15).toHexString();
    case _icfPlatformid.PlatformId.adminpro:
      return backgroundColor ? (0, _colorUtils.getHoverColor)(backgroundColor).toHexString() : (0, _colorUtils.getHoverColor)(theme.colors.primary).toHexString();
    default:
      return backgroundColor ? (0, _colorUtils.getHoverColor)(backgroundColor).toHexString() : theme.colors.primaryDark;
  }
};